import { render, staticRenderFns } from "./BusinessOrder.vue?vue&type=template&id=12a5d41c&scoped=true&"
import script from "./BusinessOrder.vue?vue&type=script&lang=js&"
export * from "./BusinessOrder.vue?vue&type=script&lang=js&"
import style0 from "./BusinessOrder.vue?vue&type=style&index=0&id=12a5d41c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a5d41c",
  null
  
)

export default component.exports